import {createStyles, Paper, Text} from '@mantine/core';
import {useMediaQuery} from '@mantine/hooks';
import {NavLink} from "react-router-dom";

const useStyles = createStyles((theme) => ({
	wrapper: {
		position: 'fixed',
		bottom: 0,
		left: 0,
		right: 0,
		display: 'flex',
		justifyContent: 'center',
		zIndex: 99,
		pointerEvents: 'none',
		paddingBottom: 18,

		[theme.fn.largerThan('sm')]: {
			display: 'none',
		},
	},

	pill: {
		display: 'flex',
		justifyContent: 'space-around',
		alignItems: 'center',
		width: '92%',
		maxWidth: 400,
		height: 60,
		borderRadius: 30,
		background: theme.colorScheme === 'dark'
			? 'rgba(30, 30, 30, 0.8)'
			: 'rgba(255, 255, 255, 0.8)',
		backdropFilter: 'blur(20px)',
		WebkitBackdropFilter: 'blur(20px)',
		border: `1px solid ${
			theme.colorScheme === 'dark'
				? 'rgba(255, 255, 255, 0.1)'
				: 'rgba(0, 0, 0, 0.08)'
		}`,
		boxShadow: theme.colorScheme === 'dark'
			? '0 4px 20px rgba(0, 0, 0, 0.4)'
			: '0 4px 20px rgba(0, 0, 0, 0.12)',
		pointerEvents: 'auto',
		padding: '0 8px',
	},

	tab: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 2,
		padding: '4px 12px',
		borderRadius: theme.radius.md,
		textDecoration: 'none',
		color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[5],
		transition: 'color 0.15s ease',
		cursor: 'pointer',
		minWidth: 0,
		flex: 1,

		'&:hover': {
			color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[7],
		},
	},

	tabActive: {
		color: theme.colors.orange[6],

		'&:hover': {
			color: theme.colors.orange[6],
		},
	},

	tabLabel: {
		fontSize: 10,
		lineHeight: 1,
		fontWeight: 500,
	},
}));

interface BottomTabBarProps {
	links: { link: string; label: string; icon: React.ReactNode }[];
}

export function BottomTabBar({links}: BottomTabBarProps) {
	const {classes, cx} = useStyles();
	const smallScreen = useMediaQuery('(max-width: 767px)');

	if (!smallScreen) return null;

	const items = links.map((link) => (
		<NavLink
			key={link.label}
			to={link.link}
			end={link.link === '/'}
			onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
			className={({isActive}) =>
				cx(classes.tab, {[classes.tabActive]: isActive})
			}
		>
			{link.icon}
			<Text className={classes.tabLabel}>{link.label}</Text>
		</NavLink>
	));

	return (
		<div className={classes.wrapper}>
			<Paper className={classes.pill} withBorder={false}>
				{items}
			</Paper>
		</div>
	);
}
